import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const WHATSAPP_LINK = 'https://wa.me/5521974393072?text=Ol%C3%A1!%20Gostaria%20de%20uma%20consulta%20jur%C3%ADdica.';

const FEATURES = [
  {
    icon: 'ri-heart-line',
    title: 'Atendimento Humanizado',
    desc: 'Tratamos cada cliente com empatia e atenção individualizada, ouvindo com cuidado cada detalhe do seu caso.',
  },
  {
    icon: 'ri-trophy-line',
    title: 'Compromisso com Resultados',
    desc: 'Nossa atuação é orientada para alcançar os melhores resultados possíveis, com dedicação total ao seu caso.',
  },
  {
    icon: 'ri-scales-line',
    title: 'Atuação Ética e Estratégica',
    desc: 'Seguimos rigorosamente as diretrizes da OAB, atuando com integridade e visão estratégica em cada processo.',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'Experiência Multidisciplinar',
    desc: 'Atuação sólida em Direito Trabalhista, Previdenciário, de Família e do Consumidor, com equipe especializada.',
  },
];

export default function About() {
  const { ref: sectionRef, isVisible } = useScrollAnimation<HTMLElement>();
  const { ref: imgRef, isVisible: imgVisible } = useScrollAnimation<HTMLDivElement>();

  return (
    <section id="sobre" className="py-24 lg:py-32 bg-bege" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div
            ref={imgRef}
            className={`reveal-left ${imgVisible ? 'visible' : ''}`}
          >
            <div className="relative">
              {/* Main image */}
              <div className="w-full h-[580px] rounded-lg overflow-hidden">
                <img
                  src="https://storage.readdy-site.link/project_files/d8bcc27c-0b18-4a10-81b7-54a88326e269/b846d4a4-11ef-40e3-a38d-b0099f9c93f5_carvalho-e-frana.jpg?v=643bded46c9f71b30cddfd0b94f132cc"
                  alt="Carvalho e França Advogadas – Equipe Profissional"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              {/* Decorative gold border */}
              <div className="absolute -bottom-5 -right-5 w-48 h-48 border-2 border-dourado-principal rounded-lg -z-10" />
            </div>
          </div>

          {/* Content Side */}
          <div className={`reveal ${isVisible ? 'visible' : ''}`}>
            <span className="font-sans text-dourado-principal text-xs tracking-widest uppercase">
              Sobre o Escritório
            </span>
            <h2 className="font-serif text-marrom-escuro text-4xl lg:text-5xl font-light mt-3 mb-6 gold-line">
              Advocacia próxima, <br />
              <span className="font-semibold">estratégica e acessível</span>
            </h2>
            <p className="font-sans text-marrom-medio text-base leading-relaxed mb-8">
              O escritório <strong>Carvalho e França Advogadas</strong> nasceu com o propósito
              de oferecer assessoria jurídica de excelência para cidadãos e trabalhadores de Duque
              de Caxias e região. Acreditamos que toda pessoa merece acesso à justiça com dignidade,
              representação qualificada e tratamento humano.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-10">
              {FEATURES.map((feat) => (
                <div
                  key={feat.title}
                  className="flex gap-4 p-4 bg-white rounded-lg border border-marrom-claro/20 hover:border-dourado-principal/40 transition-colors duration-300"
                >
                  <div className="w-10 h-10 flex items-center justify-center bg-dourado-principal/10 rounded-md flex-shrink-0">
                    <i className={`${feat.icon} text-dourado-principal text-xl`} />
                  </div>
                  <div>
                    <p className="font-serif text-marrom-escuro text-base font-semibold leading-tight">{feat.title}</p>
                    <p className="font-sans text-marrom-medio text-xs leading-relaxed mt-1">{feat.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <a
              href={WHATSAPP_LINK}
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center gap-3 bg-marrom-escuro hover:bg-grafite text-white font-sans font-bold text-sm px-8 py-4 rounded-md transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-whatsapp-line text-lg" />
              </div>
              Agendar uma Consulta
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
